import React, { Component } from 'react'
import { Header } from 'semantic-ui-react'
import Help from './Help'
import { version } from '../../package.json'

class About extends Component {
    render()
    {
        return (
        <div>
            <Header>Fragen und Antworten</Header>
            <div>v{ version }</div>
            <Help IsDesktop={false} />
        </div>
        )
    }
}
export default About